<template>
  <PlansList
    :plans="plans"
    :selected="selected"
    @update:selected="selected = $event"
    @continue="handleContinue"
    @back="handleBack"
  />
</template>

<script>
import PlansList from "@/components/plans/PlansList.vue";
import { mapActions, mapState } from "pinia";
import { useBravoStore } from "@/stores/Bravo";
export default {
  name: "OperatorsOptions",
  components: { PlansList },
  data() {
    return {
      selected: 0,
      plans: [
        {
          price: 295,
          period: "day",
          title: "الباقة اليومية",
          operators: ["mtn", "sudani", "zain"],
          popular: false,
          type: "internal",
          redirectUrl: "auth.operators.daily",
        },
        {
          price: 2800,
          period: "weekly",
          title: "الباقة الأسبوعية",
          operators: ["sudani", "bravo"],
          popular: false,
          type: "internal",
          redirectUrl: "auth.operators.weekly",
        },
        {
          price: 9900,
          period: "month",
          title: "الباقة الشهرية",
          operators: ["bravo", "sudani"],
          popular: true,
          type: "internal",
          redirectUrl: "auth.operators.monthly",
        },
        {
          price: 85000,
          period: "year",
          title: "الباقة السنوية",
          operators: ["bravo"],
          popular: false,
          type: "internal",
          redirectUrl: "bravo.pay",
        },
      ],
    };
  },
  computed: {
    ...mapState(useBravoStore, ["getPlans"]),
  },
  methods: {
    ...mapActions(useBravoStore, ["fetchPlans"]),
    async loadPlans() {
      try {
        await this.fetchPlans();
      } catch (error) {
        console.error("Error fetching plans:", error);
      }//0: Object { id: "cm8vdlnn4073o09s99zf9amz1", name: "باقة ناسنا الشهرية", plan_uuid: "bravo-monthly-plan", … } 1: Object { id: "cm8vdlnn4073o09s99zf9amz2", name: "باقة ناسنا السنوية", plan_uuid: "bravo-yearly-plan", … }
    },
    handleContinue(plan) {
      // Check if the plan has bravo operator
      if (plan.operators && plan.operators.includes("bravo")) {
        // Find matching plan from the fetched plans array
        const matchingPlan = this.getPlans.find(fetchedPlan => {
             if (plan.period === "weekly" && fetchedPlan.plan_uuid === "bravo-weekly-plan") {
            return true;
          }else if (plan.period === "month" && fetchedPlan.plan_uuid === "bravo-monthly-plan") {
            return true;
          } else if (plan.period === "year" && fetchedPlan.plan_uuid === "bravo-yearly-plan") {
            return true;
          }
          return false;
        });

        if (matchingPlan) {
          console.log("Matching plan found:", matchingPlan, matchingPlan.price);
          // Save plan details to localStorage
          localStorage.setItem('selectedPlan', JSON.stringify({
            id: matchingPlan.id,
            name: matchingPlan.name,
            plan_uuid: matchingPlan.plan_uuid,
            price: matchingPlan.price,
            period: plan.period
          }));
          
          console.log("Saved to localStorage:", {
            id: matchingPlan.id,
            name: matchingPlan.name,
            plan_uuid: matchingPlan.plan_uuid,
            price: matchingPlan.price,
            period: plan.period
          });
        }
      }

      if (plan.type === "internal") {
        this.$router.push({ name: plan.redirectUrl });
        console.log("Navigating to:", plan.redirectUrl);
      } else {
        window.location.href = plan.redirectUrl;
      }
    },
    handleBack() {
      this.$router.go(-1);
    },
  },
  async created() {
    await this.loadPlans();
    console.log("Plans loaded:", this.getPlans);
  },
};
</script>

<style scoped>
/* Responsive container for full screen background */
:host,
.plans-list {
  min-height: 100vh;
  background: radial-gradient(ellipse at top, #232326 0%, #111113 100%);
}
</style>
